import api from './client'; // Import the same shared client
const getAdminPassword = () => sessionStorage.getItem('adminPass') || '';

export const submitReport = (reportedId, reason, message) =>
  api.post(`/api/reports/${reportedId}`, { reason, message }).then(res => res.data);

export const getAdminUnreviewedReports = () =>
  api.get('/api/admin/reports/unreviewed', {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

export const getAdminAllReports = () =>
  api.get('/api/admin/reports/all', {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);

export const markReportReviewed = (reportId) =>
  api.post(`/api/admin/reports/${reportId}/reviewed`, null, {
    headers: { 'X-Admin-Password': getAdminPassword() }
  }).then(res => res.data);